<template>
  <div id="app">
    <el-main>
      <router-view :key="key" />
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'AppGov',
  computed: {
    key() {
      return this.$route.path
    },
  },
}
</script>

<style scoped lang="scss">
#app,
.el-container,
.el-main {
  height: 100%;
}

.el-main {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.el-main {
  padding: 24px;
}
</style>
